import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// import { QuoteWizardAnsweredForm } from '../components/QuoteWizard/classes';
import { generateSubmitPolicyStreamFormAnswersThunk } from '../store/policystreamStore';

// type SubmitPolicyStreamAnswersParams = Partial<
//   Parameters<typeof submitAnswersForForm>[0]
// >;
export const usePolicyStreamSubmitAnswers = () => {
  const dispatch = useDispatch();

  const submitQuote = useCallback(
    (
      localArgs: Parameters<
        typeof generateSubmitPolicyStreamFormAnswersThunk
      >[0],
    ) => {
      dispatch(
        generateSubmitPolicyStreamFormAnswersThunk({
          ...localArgs,
        }),
      );
    },
    [],
  );

  return submitQuote;
};
